<template>
  <div class="tx-mediathek-streamplayer">
    <video id="streamplayer"
           style="width: 100%;height: auto"
           width="640"
           controls
           crossorigin
           playsinline
           v-bind:poster="staticPoster"
    >
    </video>
    <div class="btn btn-success btn-livetv">Live<br>TV</div>
  </div>

</template>

<script>
import dashjs from 'dashjs/dist/dash.mediaplayer.min';
import MobileDetect from 'mobile-detect';

export default {
  name: 'Streamplayer',
  data: () => {
    return {}
  },
  computed: {
    staticPoster() {
      return mediathekPublicAssetsPath + 'Images/sk-poster-background.webp';
    },
  },
  mounted() {
    let md = new MobileDetect(window.navigator.userAgent);

    let video = document.getElementById('streamplayer'),
        s = document.createElement('source'),
        player;
    video.autoplay = false;
    video.muted = false;

    if (
        (
            md.is('iPhone')
            || md.match('iPad')
            || md.match('Macintosh')
        )
        && !md.match('Firefox')
        && !md.match('Chrome')
    ) {
      console.info('🌞️ stream-player: using HLS/m3u8 for Safari');
      s.src = "https://euvia.cdn.ses-ps.com/secure/HLS-Live/index.m3u8";
      s.type = "application/x-mpegurl";
      video.append(s);
    } else {
      console.info('🌞️ stream-player: using djs');
      let url = "https://euvia.cdn.ses-ps.com/secure/DASH-Live/manifest.mpd";

      // s.src = url;
      // s.type = "application/dash+xml";
      // video.append(s);

      if (video) {
        let djs = dashjs.MediaPlayer().create();
        djs.initialize(video, url, true);
      }
    }

  }
}
</script>

<style lang="scss">
</style>